// Import CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "tippy.js/dist/tippy.css";
import "@css/app.css";

// Register loading indicators
import "ldrs/ring";

// Swiper
import Swiper from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";

const swiper = new Swiper(".swiper", {
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".swiper-button-next-custom",
    prevEl: ".swiper-button-prev-custom",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    bulletActiveClass: "!bg-ux-blue !opacity-100 border-ux-blue",
    bulletClass:
      "w-3 h-3 inline-block rounded-full border border-neutral-200 mx-1",
  },
});

const productSwiper = new Swiper(".product-carousel", {
  modules: [Navigation, Pagination],
  navigation: {
    nextEl: ".product-swiper-button-next",
    prevEl: ".product-swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const productLightboxThumbs = new Swiper(".product-lightbox-thumbs", {
  spaceBetween: 20,
  slidesPerView: 4.8,
  freeMode: true,
  watchSlidesProgress: true,
});

const productLightboxSwiper = new Swiper(".product-lightbox-carousel", {
  modules: [Navigation, Thumbs],
  navigation: {
    nextEl: ".product-swiper-button-next",
    prevEl: ".product-swiper-button-prev",
  },
  thumbs: {
    swiper: productLightboxThumbs,
  }
});


const carousel = new Swiper(".carousel", {
  modules: [Navigation],
  slidesPerView: "auto",
  spaceBetween: 30,
  navigation: {
    nextEl: ".carousel-button-next",
    prevEl: ".carousel-button-prev",
  },
});

import tippy from "tippy.js";
const profileMenu = document.querySelector('#profile-menu');
const profileMenuButton = document.querySelector('#profile-menu-button');
tippy('#profile-menu-button', {
  placement: 'bottom-start',
  theme: 'vestlandshus',
  arrow: false,
  trigger: 'click',
  interactive: true,
  content: profileMenu?.innerHTML,
  allowHTML: true,
});

// Vue JS
import { createApp } from "vue";
import { createPinia } from "pinia";
import ProductDatabase from "./productDatabase/components/ProductDatabase.vue";
import ImageDatabase from "./imageDatabase//components/ImageDatabase.vue";
if (document.getElementById('product-database')) {
  const productDatabaseApp = createApp(ProductDatabase);
  productDatabaseApp.use(createPinia());
  productDatabaseApp.mount("#product-database");
}
if (document.getElementById('image-database')) {
  const imageDatabaseApp = createApp(ImageDatabase);
  imageDatabaseApp.use(createPinia());
  imageDatabaseApp.mount("#image-database");
}

// Put Alpine last, so that it has access to other JS modules
import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
